import { Component } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { authCodeFlowConfig } from 'src/app/auth.config';
import { NavigationService } from 'src/app/services/navigation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent {

  profileSelectionError?: string = sessionStorage.getItem('profileError');
  constructor(private oauthService: OAuthService,  private navigationService: NavigationService) {
    this.navigationService.appLogout(false);
   }

  login() {
    sessionStorage.removeItem('profileError');
    this.oauthService.configure(authCodeFlowConfig);
    this.oauthService.loadDiscoveryDocument(environment.discoveryDocumentUrl).then(() => {
      this.oauthService.initCodeFlow();
    });
  }

  reportLogin() {
    this.oauthService.redirectUri = environment.reportingBaseUrl;
    this.login();
  }

  showSessionTimeoutAlert() {
    return sessionStorage.getItem('sessionTimedOut') && !this.oauthService.hasValidAccessToken();
  }

}
